var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _path2, _path3, _polygon, _path4, _path5, _path6, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCGs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 138.59 35.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M4.47,17.07h.88c0-2.96,1.03-5.65,2.86-7.54l-1.28-1.41c-1.57,2.68-2.46,5.79-2.46,8.95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -186.48,
    y1: -343.69,
    x2: -185.33,
    y2: -343.69,
    gradientTransform: "translate(-1194.53 -2207.37) rotate(-180) scale(6.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fabe00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9c500"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M4.47,17.07c0,3.21.57,6.2,1.7,8.81l1.81-2.48c-1.6-1.52-2.63-3.57-2.63-6.31v-.02h-.88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -62.63,
    y1: -348.79,
    x2: -61.48,
    y2: -348.79,
    gradientTransform: "translate(-1924.34 364.37) rotate(90) scale(5.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9c500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fbe26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M34.43,16.48c2.27.03,3.66,1.79,3.62,4.02h.88c0-2.21-1.03-4.21-2.86-5.71l-1.64,1.69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -50.05,
    y1: -360.65,
    x2: -48.9,
    y2: -360.65,
    gradientTransform: "translate(-1661.91 251.09) rotate(89.99) scale(4.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ecef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b3c4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M38.04,20.5c-.04,1.84-1.02,3.38-3.21,4.53l2.3,3.17c1.12-2.07,1.79-4.62,1.79-7.7h0s-.88,0-.88,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -206.59,
    y1: -365.59,
    x2: -205.45,
    y2: -365.59,
    gradientTransform: "translate(-942.06 -1714.22) rotate(-180) scale(4.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b3c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009e96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12.52,18.3c-1.47,0-2.6-1.62-2.6-3.19,0-.16.01-.32.03-.48l-.81-.14c-.06.34-.1.69-.1,1.06,0,5.27,3.93,8.63,8.88,8.63,9.42,0,12.22-7.7,16.44-7.7h.07s1.64-1.69,1.64-1.69c-2.04-1.68-5.06-2.72-8.72-2.72-7.46,0-11.44,6.23-14.82,6.23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -105.93,
    y1: -283.95,
    x2: -104.79,
    y2: -283.95,
    gradientTransform: "translate(2178.15 5827.19) scale(20.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0068b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ecef4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.93,8.12l1.28,1.41c1.65-1.71,3.96-2.77,6.76-2.77,5.45,0,9.23,4.12,14.09,4.12,5.83,0,9.05-2.84,9.86-8.39l-.88-.15c-.25,1.47-1.2,3.23-2.92,3.23-1.62,0-3.34-1.42-5.84-2.8-2.5-1.42-5.38-2.79-8.96-2.79-5.77,0-10.63,3.4-13.39,8.12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -112.78,
    y1: -284.26,
    x2: -111.64,
    y2: -284.26,
    gradientTransform: "translate(3157.77 7947.04) scale(27.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fabe00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f08000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb6101"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.18,25.88c2.6,5.98,8.15,9.93,16.45,9.93,5.49,0,11.57-2.18,14.5-7.61l-2.3-3.17c-2.71,1.42-7.26,2.24-14.16,2.24-4.22,0-9.55-.92-12.68-3.87l-1.81,2.48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -109.23,
    y1: -284.02,
    x2: -108.08,
    y2: -284.02,
    gradientTransform: "translate(2570.13 6692.02) scale(23.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7fbe26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009e96"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#linear-gradient)",
    x: 1.86,
    y: 8.11,
    width: 8.97,
    height: 8.97,
    transform: "translate(-7.05 8.18) rotate(-45)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#linear-gradient-2)",
    x: 1.88,
    y: 17.12,
    width: 8.71,
    height: 8.71,
    transform: "translate(-13.36 10.7) rotate(-45)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#linear-gradient-3)",
    x: 33.07,
    y: 14.04,
    width: 7.22,
    height: 7.22,
    transform: "translate(-1.74 31.1) rotate(-44.99)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#linear-gradient-4)",
    x: 32.71,
    y: 20.19,
    width: 8.34,
    height: 8.34,
    transform: "translate(-6.42 33.21) rotate(-45)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#linear-gradient-5)",
    x: 9.04,
    y: 12.07,
    width: 27.03,
    height: 12.12
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#linear-gradient-6)",
    x: 6.93,
    width: 31.99,
    height: 10.89
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#linear-gradient-7)",
    x: 6.18,
    y: 23.4,
    width: 30.96,
    height: 12.41
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M53.43,26.8c-5.46,0-8.47-3.59-8.47-8.9s3.26-8.94,8.57-8.94c2.12,0,3.89.49,5.26,1.27l-.57,3.71c-1.3-.83-2.82-1.47-4.58-1.47-2.97,0-4.41,2.19-4.41,5.41s1.49,5.5,4.46,5.5c.95,0,1.62-.17,2.32-.55v-3.06h-2.99l-.49-3.16h7.2v8.37c-1.79,1.17-3.91,1.82-6.28,1.82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M67.88,26.67c-2.32,0-4.26-.5-6-1.29l.62-3.64c1.77.95,3.74,1.59,5.46,1.59,1.22,0,2.07-.52,2.07-1.54s-.5-1.42-2.92-2.34c-3.43-1.32-4.93-2.44-4.93-5.28,0-3.31,2.59-5.08,5.88-5.08,2.24,0,3.69.42,5.18,1.15l-.65,3.59c-1.54-.9-3.16-1.39-4.48-1.39s-1.92.54-1.92,1.34c0,.88.47,1.3,2.61,2.12,3.74,1.37,5.23,2.67,5.23,5.41,0,3.74-2.74,5.38-6.16,5.38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M86.96,26.78c-5,0-7.94-3.58-7.94-8.75s3.06-8.8,7.79-8.8c2.09,0,3.7.54,5,1.47l-.29,1.74c-1.25-1.01-2.8-1.69-4.73-1.69-3.78,0-6.03,2.89-6.03,7.26s2.26,7.23,6.23,7.23c1.59,0,2.75-.37,3.87-1.05v-5.07h-4.07l-.25-1.52h5.98v7.48c-1.57,1.03-3.38,1.72-5.56,1.72"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    points: "95.97 26.46 95.97 9.15 97.56 8.86 97.56 26.46 95.97 26.46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M105.41,15.99c-2.3,0-3.55,1.94-3.55,4.68s1.27,4.66,3.55,4.66,3.6-1.91,3.6-4.66-1.28-4.68-3.6-4.68M105.41,26.71c-2.97,0-5.2-2.21-5.2-6.03s2.28-6.05,5.2-6.05,5.27,2.21,5.27,6.05-2.3,6.03-5.27,6.03"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M118.15,16.07c-1.3,0-2.38.81-3.41,2.01v6.67c.74.29,1.5.47,2.67.47,2.3,0,3.92-1.5,3.92-4.8,0-2.82-1.35-4.34-3.18-4.34M117.34,26.61c-1.62,0-2.92-.32-4.22-.76V9.15l1.62-.29v7.52c.83-.91,1.96-1.76,3.58-1.76,2.53,0,4.66,1.84,4.66,5.71,0,4.24-2.43,6.28-5.64,6.28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M132.17,20.31c-4.56.46-5.83,1.57-5.83,3.14,0,1.25.86,1.89,2.08,1.89s2.62-.69,3.75-1.74v-3.28ZM132.54,26.46l-.27-1.55c-1.08,1.01-2.43,1.79-4.09,1.79-2.01,0-3.46-1.1-3.46-3.16,0-2.72,2.21-4,7.45-4.51v-.76c0-1.57-.93-2.23-2.4-2.23-1.37,0-2.72.42-3.99,1.03l-.22-1.45c1.35-.59,2.67-1,4.32-1,2.57,0,3.9,1.2,3.9,3.58v8.26h-1.22Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    points: "137 26.46 137 9.15 138.59 8.86 138.59 26.46 137 26.46"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCGs);
export default __webpack_public_path__ + "static/media/c_gs.093349cdfe752ecfd8c66657b40fbab0.svg";
export { ForwardRef as ReactComponent };